import React from 'react';
import ContainerFlex from '~/components/containerFlex';
import Grid from '~/components/grid';
import RadioButton from '~/components/radioButton';

import * as St from '../../style';

export type TCampaingCriteriosPesquisaProps = {
  baseDados: string;
  setBaseDados: React.Dispatch<React.SetStateAction<string>>;
};

const dataRadioBtn = [
  {
    id: '1',
    tipe: 'BOX_BASE_CLIENTES',
    value: 'Box base de clientes',
  },
  // {
  //   id: '2',
  //   tipe: 'BOX_PROPOSTA',
  //   value: 'Box proposta',
  // },
  // {
  //   id: '3',
  //   tipe: 'BOX_FATURA',
  //   value: 'Box fatura',
  // },
];

const CampaingCriteriosPesquisa = ({
  baseDados,
  setBaseDados,
}: TCampaingCriteriosPesquisaProps): JSX.Element => {
  return (
    <>
      <ContainerFlex row wrap marginTop={10} marginLeft={10}>
        <St.TitleLevelSmall>
          Escolha de qual base a campanha irá procurar os clientes atingidos
        </St.TitleLevelSmall>
      </ContainerFlex>

      <Grid
        xs={1}
        lg={2}
        xl={5}
        gap={50}
        style={{ marginTop: '0.5%', marginLeft: '2%' }}
      >
        {dataRadioBtn.map((el) => (
          <ContainerFlex row center key={el.id}>
            <RadioButton
              id={el.id}
              name={el.tipe}
              checked={baseDados === el.tipe}
              onClick={() => setBaseDados(el.tipe)}
            />
            {el.value}
          </ContainerFlex>
        ))}
      </Grid>
    </>
  );
};

export default CampaingCriteriosPesquisa;
